import React from 'react';
import {
  dataGridDateSorter,
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { IconButton } from '../../../../../../common/controls/Controls.jsx';
import {
  CreditCardOutlined,
  TeamOutlined,
  FileSearchOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { routes } from '../../../../../../../utils/helpers/ApiClient.jsx';
import { QuestionModal } from '../../../../../../common/index.jsx';
import { Tag } from 'antd';
import {
  FIJ_JOB_STATUS,
  statusColorJob,
} from '../../../../../../../utils/constants/enums.js';

export const MyJobsConfig = ({ t, navigate, handlers, filterHooks, permissions }) => {
  return {
    columns: [
      {
        title: t('Názov'),
        dataIndex: 'name',
        width: 180,
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...filterHooks.nameTextFilterProps,
      },
      {
        title: t('Začiatok'),
        dataIndex: 'date_from',
        width: 120,
        sorter: dataGridDateSorter('date_from'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...filterHooks.fromDateRangeFilterProps,
      },
      {
        title: t('Koniec'),
        dataIndex: 'date_to',
        sorter: dataGridDateSorter('date_to'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...filterHooks.toDateRangeFilterProps,
      },
      {
        title: t('Kapacita'),
        dataIndex: 'student_capacity',
        sorter: dataGridNumberSorter('student_capacity'),
      },
      {
        title: t('Záujem'),
        dataIndex: 'interested',
        sorter: dataGridNumberSorter('interested'),
      },
      {
        title: t('Praktikanti'),
        dataIndex: 'accepted',
        sorter: dataGridNumberSorter('accepted'),
      },
      {
        title: t('Stav'),
        dataIndex: 'status',
        sorter: dataGridTextSorter('status'),
        ...filterHooks.statusTextFilterProps,
        render: (status) => (
          <Tag color={statusColorJob(status)}>{t(status)}</Tag>
        ),
      },
    ],

    customActions: (record) => (
      <div style={{ display: 'flex' }}>
        <IconButton
          icon={<EditOutlined />}
          tooltip={t('Upraviť')}
          disabled={
            !permissions?.isFijAdmin &&
            record.status !== FIJ_JOB_STATUS.WAITING
          }
          disabledTooltip={t(
            'FRI Prax nie je možné upraviť, už bola schválená',
          )}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${routes.cmsFijJobEdit}/${record.id}`);
          }}
        />
        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail')}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${routes.cmsFijJobDetail}/${record.id}`);
          }}
        />
        <IconButton
          icon={<TeamOutlined />}
          tooltip={t('Zobraziť záujemcov / praktikantov')}
          disabled={
            (record.interested === 0 || record.interested === '0') &&
            (record.accepted === 0 || record.accepted === '0')
          }
          disabledTooltip={t('Nie sú záujemcovia / praktikanti')}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${routes.cmsFijInterestedStudents}/${record.id}`);
          }}
        />
        <IconButton
          icon={<CreditCardOutlined />}
          tooltip={t('Archivovať')}
          onClick={(e) => {
            e.stopPropagation();
            handlers.openArchiveModal(record);
          }}
        />
      </div>
    ),

    modals: ({ modalState, closeModal, onConfirm }) => (
      <QuestionModal
        chosenPositive={onConfirm}
        question={t(
          'Naozaj chcete archivovať vybranú FRI prax? Prax sa nebude ponúkať študentom a bude zobrazená len v archíve.',
        )}
        visible={modalState.type === 'archive'}
        yes={t('Áno')}
        toggle={closeModal}
        headerTitle={t('Archivovať')}
      />
    ),
  };
};
